import { SpinnerContainer, SpinnerOverlay } from './spinner.styles';

const Spinner = () => (
	<SpinnerContainer>
		<SpinnerOverlay />
	</SpinnerContainer>
);

export default Spinner;
